import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ClienteDatosCP;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre cliente", cell: x => ({ data: x.NombreCliente }) }
];

export interface BotonesDeps {
    onImprimirCartaPorteEAD: (x: Entity) => void;
    onDescargarCartaPorteEAD: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps,IdViajeEad: number): Column[] {
    debugger
    const botones = kea.columnaBotones([
        {
            iconClass: fa("file"),
            tooltip: "Descargar xml Carta Porte",
            style: "default",
            onClick: deps.onDescargarCartaPorteEAD,
        },{
            iconClass: fa("print"),
            tooltip: "imprimir pdf carta porte",
            style: "default",
            onClick: deps.onImprimirCartaPorteEAD,
        }
    ]);
    return [...columnasFijas,botones];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/list/columnsModal.tsx